import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, Alert, CircularProgress } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { validateUrl } from '../ProxyUtils';

const CreateGroupDialog = React.memo(function CreateGroupDialogComponent({ open, onClose, onCreate }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [urls, setUrls] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) {
            setName('');
            setDescription('');
            setUrls('');
            setError(null);
            setIsCreating(false);
        }
    }, [open]);

    const handleCreate = async () => {
        setError(null);
        if (!name.trim() || !description.trim() || !urls.trim()) {
            setError('Compilare tutti i campi');
            return;
        }

        const urlList = urls.split('\n').map(u => u.trim()).filter(u => u !== '');
        const invalid = urlList.filter(u => !validateUrl(u));
        if (invalid.length) {
            setError(`URL non validi: ${invalid.join(', ')}`);
            return;
        }

        setIsCreating(true);
        try {
            await onCreate({ name: name.trim(), description: description.trim(), urls: urlList });
        } catch (e) {
            setError('Errore durante la creazione: ' + e.message);
            setIsCreating(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth keepMounted={false}>
            <DialogTitle>Crea Nuovo Gruppo Whitelist</DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{ mb: 2, mt: 1 }}>{error}</Alert>}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Nome Gruppo"
                        autoFocus
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        required
                        placeholder="Es. Social Media"
                    />
                    <TextField
                        label="Descrizione"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        required
                        multiline
                        rows={2}
                    />
                    <TextField
                        label="URL (uno per riga)"
                        value={urls}
                        onChange={(e) => setUrls(e.target.value)}
                        fullWidth
                        required
                        multiline
                        rows={8}
                        placeholder="example.com"
                    />
                    <Typography variant="caption" color="textSecondary">
                        Inserire un URL per riga. Supportati pattern wildcard (es. example.com).
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isCreating}>Annulla</Button>
                <Button
                    onClick={handleCreate}
                    variant="contained"
                    disabled={isCreating || !name.trim() || !description.trim() || !urls.trim()}
                    startIcon={isCreating ? <CircularProgress size={20} /> : <SaveIcon />}
                >
                    {isCreating ? 'Creando...' : 'Crea Gruppo'}
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default CreateGroupDialog;